// src/pages/PromoPage.js (create this file if it doesn't exist, adjust path as needed)
import React, { useEffect } from 'react';
import { Share2 } from 'lucide-react';

const PromoPage = () => {
  // Promotion Details
  const bankIslamApplicationUrl = 'https://www.myron.com/affliation-link?=1woqep-123qwe/'; // IMPORTANT: REPLACE with actual specific promo application URL
  const pageImage = 'https://fastly.picsum.photos/id/0/5000/3333.jpg?hmac=_j6ghY5fCfSD6tvtcV74zXivkJSPIfR9B8w34XeQmvU';
  const pageTitle = "Bank Islam PayDay Advantage!";
  const pageDescription = "Don't miss out on our exclusive PayDay offer! Get RM50 Cashback when you apply for a Bank Islam Credit Card-i. See full terms below and apply now!";
  
  // Full promotional text for display on the page and for sharing
  const promoTextForSharing = `Secure your financial perks this Payday! Apply for a Bank Islam Credit Card-i and receive RM50 Cashback!\n\nUse Promo Code during application: BIPAYDAY\n\nOffer valid from May 25th - May 30th, 2025.\nCashback credited upon card approval and min. retail spend of RM200 on your new card within 30 days.\n\nApply now:`;

  // useEffect for attempting HTTPS redirect if share APIs might be unavailable on HTTP
  useEffect(() => {
    if (typeof navigator.share === "undefined" || typeof navigator.canShare === "undefined") {
      if (window.location.protocol === 'http:') {
        console.log("Share APIs potentially unavailable & on HTTP (PromoPage). Attempting redirect to HTTPS.");
        window.location.replace(window.location.href.replace(/^http:/, 'https:'));
      }
    }
  }, []);

  const handleSharePromotion = async () => {
    const shareTitle = pageTitle; 
    const textToShare = promoTextForSharing; 
    const urlToShare = bankIslamApplicationUrl; 
    const imageToFetchUrl = pageImage;
    const imageFilename = "bank-islam-promo.jpg"; 
    const imageMimeType = 'image/jpeg'; 

    if (!navigator.share) {
      console.log("Web Share API not supported. Fallback to clipboard.");
      try {
        await navigator.clipboard.writeText(textToShare);
        alert('Promotion details copied to clipboard! (Sharing feature not supported on this browser)');
      } catch (err) {
        console.error('Failed to copy to clipboard:', err);
        alert('Failed to copy promotion details.');
      }
      return;
    }

    try {
      console.log("Attempting to fetch image for sharing:", imageToFetchUrl);
      const response = await fetch(imageToFetchUrl);
      if (!response.ok) {
        throw new Error(`Image fetch failed: ${response.status}`);
      }
      const blob = await response.blob();
      const file = new File([blob], imageFilename, { type: imageMimeType });
      const filesArray = [file];

      const shareDataWithFiles = { title: shareTitle, text: textToShare, url: urlToShare, files: filesArray };
      const shareDataTextOnly = { title: shareTitle, text: textToShare, url: urlToShare };

      if (navigator.canShare && navigator.canShare({ files: filesArray })) {
        console.log("Browser can share files. Sharing with files:", JSON.stringify(shareDataWithFiles, null, 2));
        await navigator.share(shareDataWithFiles);
        console.log('Promotion shared successfully with image.');
      } else {
        console.log("Browser cannot share files. Sharing text and URL only.");
        await navigator.share(shareDataTextOnly);
        console.log('Promotion shared successfully (text and URL only).');
      }
    } catch (error) {
      console.error('Sharing failed:', error.message);
      try {
        console.log("General error during share process. Fallback: Sharing text and URL only.");
        await navigator.share({ title: shareTitle, text: textToShare, url: urlToShare });
        console.log('Promotion shared successfully (text and URL only - fallback).');
      } catch (fallbackError) {
        console.error('Text-only share fallback also failed:', fallbackError);
        try {
          await navigator.clipboard.writeText(textToShare);
          alert('Promotion details copied to clipboard! (Sharing failed)');
        } catch (errClipboard) {
          console.error('Failed to copy to clipboard after all fallbacks:', errClipboard);
          alert('Failed to share or copy details. Please try again later.');
        }
      }
    }
  };

  return (
    <div className="z-orange-pattern min-h-screen px-4 py-8 pt-28 md:pt-32"> {/* Added padding-top for sticky header */}
      <div className="max-w-3xl mx-auto bg-white p-6 md:p-10 rounded-3xl shadow-2xl ring-1 ring-black/5">
        <img
          src={pageImage}
          alt="Promotion Visual"
          className="w-full h-auto object-cover rounded-2xl shadow-md mb-6 md:mb-8"
          style={{ maxHeight: '400px' }} // Constrain image height
        />
        <div className="text-center mb-6 md:mb-8">
          <span className="z-eyebrow">Tawaran Istimewa</span>
          <h1 className="font-serif-display text-3xl md:text-4xl font-semibold text-[var(--z-ink)] mt-2 mb-3">{pageTitle}</h1>
          <p className="text-lg text-[var(--z-muted)]">{pageDescription}</p>
        </div>

        <div className="bg-[var(--z-cream)] border border-[var(--z-line)] p-4 md:p-6 rounded-2xl mb-8">
          <h2 className="font-serif-display text-xl md:text-2xl font-semibold text-[var(--z-ink)] mb-3">Full Offer Details:</h2>
          {/* Preserve newlines in display */}
          <pre className="text-[var(--z-muted)] whitespace-pre-wrap font-sans text-sm md:text-base leading-relaxed">{promoTextForSharing}</pre>
        </div>

        <button
          onClick={handleSharePromotion}
          className="btn-accent w-full md:w-auto md:mx-auto text-lg focus:outline-none focus:ring-2 focus:ring-[var(--z-accent-100)]"
        >
          <Share2 size={22} className="mr-3" />
          Share This Promotion
        </button>
      </div>
    </div>
  );
};

export default PromoPage;